import React, { useState, useEffect } from 'react';
import { wsGetAll } from 'services/WService';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Card from 'components/Card/Card';
import { Collapse } from '@material-ui/core';
import CardHeader from 'components/Card/CardHeader';
import FilterArticle from 'hooks/FilterArticle';
import { ArrowDropDown } from '@material-ui/icons';

export default function ModalPrice(props) {
  const price = props.model;

  const [dataChanging, setDataChanging] = useState(price);
  const [priceLists, setPriceLists] = useState([]);

  const [checkDisplay, setCheckDisplay] = useState(true);
  const [nameArticle, setNameArticle] = useState('');

  function setOpen() {
    props.setOpen({ open: false });
    setNameArticle('');
  }

  async function getPriceList() {
    let response = await wsGetAll('logi/price-list');
    if (response.success) setPriceLists(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value
    });
  }

  useEffect(() => {
    if (price.open) getPriceList();
    if (price.open && !!price.ItemName) {
      setNameArticle(price.ItemName);
    }
  }, [price.open]);

  return (
    <Modal
      title={`Precio - ${props.priceList?.ListName || ''}`}
      model={price}
      setOpen={setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/price"
      state
    >
      {!!price.id ? undefined : (
        <Autocomplete
          options={priceLists}
          getOptionLabel={(option) => option.ListName}
          defaultValue={
            !!price
              ? priceLists.find((priceList) => priceList.id == price.logi_price_list_id)
              : undefined
          }
          renderInput={(params) => (
            <TextField {...params} label="Lista de precios" margin="normal" required />
          )}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('logi_price_list_id', item.id);
            }
            handleChange('logi_price_list_id', null);
          }}
        />
      )}
      {!price.logi_product_id ? (
        <Card style={{ margin: 0, marginTop: '20px' }}>
          <CardHeader
            style={{ cursor: 'pointer', alignItems: 'center' }}
            onClick={() => {
              setCheckDisplay((prev) => !prev);
            }}
            icon
          >
            <h4
              style={{
                color: 'black',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end'
              }}
            >
              {nameArticle === '' ? 'Selecciona producto' : nameArticle}
              <ArrowDropDown />
            </h4>
          </CardHeader>
          <Collapse in={checkDisplay} key={1}>
            <div
              elevation={4}
              style={{
                padding: '10px',
                margin: 'auto',
                marginBottom: '8px !important',
                width: '100%'
              }}
            >
              <FilterArticle
                fullWidth={true}
                article
                defaultValue={price}
                setNameArticle={setNameArticle}
                setDataChanging={setDataChanging}
                dataChanging={dataChanging}
                required
              />
            </div>
          </Collapse>
        </Card>
      ) : (
        <h4 style={{ textAlign: 'center' }}>{nameArticle}</h4>
      )}

      <TextField
        label="Precio unidad"
        fullWidth
        type="number"
        name="unit_price"
        margin="normal"
        inputProps={{
          min: 0,
          step: 0.0001
        }}
        defaultValue={!!price ? price.unit_price : ''}
        required
      />
      <TextField
        label="precio paquete"
        fullWidth
        type="number"
        name="package_price"
        margin="normal"
        inputProps={{
          min: 0,
          step: 0.0001
        }}
        defaultValue={!!price ? price.package_price : ''}
        required
      />
    </Modal>
  );
}
